import { IUserMention } from '../../../../../../markdown.types';
import { ALLOWED_SYMBOLS_BEFORE_ENTITY } from '../../../getSymbolsChecks.constants';
import { ISymbolsHandler } from '../../../getSymbolsChecks.types';
import { isValidStartPosition } from '../../../utils/isValidStartPosition/isValidStartPosition';

export const handlerMention =
  (userMentions: IUserMention[]): ISymbolsHandler =>
  (opts) => {
    const { text, index, symbolMatches } = opts;

    if (
      !userMentions ||
      !userMentions.length ||
      !isValidStartPosition({ text, index, allowedSymbols: ALLOWED_SYMBOLS_BEFORE_ENTITY })
    ) {
      return;
    }

    for (let i = 0; i < userMentions.length; i++) {
      const userMention = userMentions[i];

      const mentionStartIndex = index + 1;
      const mentionEndIndex = mentionStartIndex + userMention.nickname.length;
      const mention = text.substring(mentionStartIndex, mentionEndIndex);

      if (mention.toLowerCase() === userMention.nickname.toLowerCase()) {
        symbolMatches['@'].push({
          start: index,
          end: mentionEndIndex,
          userMention,
        });
        break;
      }
    }
  };
